import { Skeleton } from '@/components/ui/skeleton'

export function DashboardPageSkeleton() {
  return (
    <div className="space-y-6">
      <div>
        <Skeleton className="h-8 w-64" />
        <Skeleton className="mt-1 h-4 w-96" />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="rounded-lg border bg-background p-4">
            <Skeleton className="h-8 w-32" />
            <Skeleton className="mt-2 h-4 w-28" />
            <Skeleton className="mt-3 h-4 w-24" />
          </div>
        ))}
      </div>

      <div className="rounded-lg border bg-card p-6">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="mt-4 h-72 w-full" />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="rounded-lg border bg-card p-6 lg:col-span-2">
          <Skeleton className="h-5 w-48" />
          <Skeleton className="mt-4 h-4 w-full" />
          <Skeleton className="mt-2 h-4 w-3/4" />
        </div>
        <div className="rounded-lg border bg-card p-6">
          <Skeleton className="h-5 w-48" />
          <Skeleton className="mt-4 h-4 w-full" />
          <Skeleton className="mt-2 h-4 w-3/4" />
        </div>
      </div>
    </div>
  )
}
